import { toSlug } from '../utils/slug';
import { REF_QUERY_PARAM, REF_POPULAR_CHIP } from '../../constants';
import { usePopularSearches } from '../hooks/usePopularSearches';

const CHIP_COUNT = 3;

// Fallback when featureFlags.popularSearchChips.ui is off or the fetch fails/returns
// empty - curated from real search volume (searchTerms collection), same terms as
// before this became dynamic. Links point at the Cloudflare-served static ISR pages
// (/search/{slug}, see docs/seo-lazy-isr-design.md), giving Google a crawl path into
// them without waiting for sitemap pickup. If a term hasn't been published to KV yet,
// the Worker 302-redirects to the live SPA search - never a dead end.
const FALLBACK_SEARCH_TERMS = [
  'Melitta Solo',
  'Sage Bambino Plus',
  'Sage Barista Pro',
  'Breville Bambino Plus',
  'Lelit Elizabeth',
  'Lelit Anna',
  'Eureka Mignon Specialita',
  'DeLonghi Dedica Style EC685',
  'DeLonghi Rivelia',
  'Ninja Luxe Cafe',
];

function pickRandom(terms, count) {
  const shuffled = [...terms];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled.slice(0, count);
}

export default function PopularSearches() {
  const dynamicTerms = usePopularSearches();
  const pool = dynamicTerms.length > 0 ? dynamicTerms : FALLBACK_SEARCH_TERMS;
  const chips = pickRandom(pool, CHIP_COUNT);

  return (
    <section className="max-w-3xl mx-auto px-4 py-8 text-center" aria-label="חיפושים פופולריים">
      <h2 className="text-lg font-semibold text-white mb-3">חיפושים פופולריים</h2>
      <ul className="flex flex-wrap justify-center gap-2">
        {chips.map((term) => (
          <li key={term}>
            <a
              href={`/search/${toSlug(term)}?${REF_QUERY_PARAM}=${REF_POPULAR_CHIP}`}
              className="inline-block px-3 py-1.5 rounded-full bg-white/10 !text-white text-sm hover:bg-white/20 transition-colors focus:outline-none focus:ring-2 focus:ring-white/50"
            >
              {term}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
